import React, { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { ToastContainer, toast } from "react-toastify";
import {
  getSurveyDetails,
  buttonDisplay,
  activeProcessBar,
  updateSurveStatus,
  editCompletionDateFunc,
  getAllQualitySupervisors,
  submitFormData,
} from "../../Utils/adminFunctions";
import {
  generateSurveyID,
  generateDeviceID,
  generateParticipantGroupID,
  get_Date,
  minCurrentDate,
  getCompleteSurveyDate,
  time_with_AMPM,
  getSurveyStatusName,
} from "../../Utils/commonFunctions";
import ScaleLoader from "react-spinners/ScaleLoader";


let AdminSurveyDetails = () => {
  const [surveyDetails, setSurveyDetails] = useState("");
  const [surveyFeedback, setSurveyFeedback] = useState("");
  const [editCompletionDate, setEditCompletionDate] = useState("");
  const [isSurveyEdit, setIsSurveyEdit] = useState(0);
  const { surveyID } = useParams();
  const [minDate, setMinDate] = useState(null);
  const [disable, setDisable] = useState(false);
  const [listUsers, setListUsers] = useState([]);
  const [desabledBtn, setDesabledBtn] = useState(false);
  const [notifyUsersData, setNotifyUsersData] = useState([]);

  useEffect(() => {
    manageSurveyDetails();
    setMinDate(minCurrentDate);
  }, []);
  const manageSurveyDetails = async () => {
    const response = await getSurveyDetails(surveyID);
    
    if (response.status === "success") {
      manageQualitySupervisorUser(response.results.site_id);
      setNotifyUsersData(response.results.users);
      setSurveyDetails(response.results);
      setSurveyFeedback(response.results.survey_feedback);
      setEditCompletionDate(
        getCompleteSurveyDate(response.results.completion_date)
      );
      if (
        response.results.status === "draft_created" ||
        response.results.status === "draft_released_to_primary_user"
      ) {
        setIsSurveyEdit(1);
      } else {
        setIsSurveyEdit(0);
      }
    } else {
      toast.error(response.message, { autoClose: 1500 });
    }
  };
  const handleEditCompletionDate = async () => {
    const response = await editCompletionDateFunc(surveyID, editCompletionDate);
    if (response.status === "success") {
      manageSurveyDetails();
      setEditCompletionDate("");
      toast.success(response.message, { autoClose: 1500 });
    } else {
      toast.error(response.message, { autoClose: 1500 });
    }
  };

  const handleSurveyStatus = async (surveyStatus) => {
    setDisable(true);
    const response = await updateSurveStatus(surveyID, surveyStatus);
    if (response.status === "success") {
      manageSurveyDetails();
      toast.success(response.message, { autoClose: 1500 });
      setDisable(false);
    } else {
      toast.warning(response.message, { autoClose: 1500 });
      setDisable(false);
    }
  };

  const manageQualitySupervisorUser = async (site_id) => {
    let bodyFormData = new FormData();
    bodyFormData.append("site_id", site_id);
    bodyFormData.append("survey_id", surveyID);
    const response = await getAllQualitySupervisors(bodyFormData);
    if (response.status === "success") {
      setListUsers(response.data);
    } else {
      setListUsers([]);
      toast.error(response, { autoClose: 1500 });
    }
  };
  const handleChangeUsers = (e) => {
    const { name, checked } = e.target;
    if (name === "allselect") {
      let tempUser = listUsers.map((user) => {
        return { ...user, isChecked: checked, role: e.target.dataset.role };
      });
      setListUsers(tempUser);
    } else {
      let tempUser = listUsers.map((user) => {
        return user.user_id == name
          ? { ...user, isChecked: checked, role: e.target.dataset.role }
          : user;
      });
      setListUsers(tempUser);
    }
  };
  const handlersendrequesttousers = async () => {
    setDesabledBtn(true);
    const checkedUsers = [];
    const roles = [];
    for (let i = 0; i < listUsers.length; i++) {
      if (listUsers[i].isChecked === true) {
        checkedUsers.push(parseInt(listUsers[i].user_id));
        roles.push(listUsers[i].role);
      }
    }
    if (checkedUsers.length != 2) {
      setDesabledBtn(false);
      toast.warning("Please select only two users.", {
        autoClose: 1500,
      });
      return false;
    } else if (
      (roles.includes("Primary User") || roles.includes("Secondary User")) &&
      roles.includes("Quality Supervisor")
    ) {
      const bodyFormData = new FormData();
      bodyFormData.append("survey_id", surveyID);
      bodyFormData.append("users", checkedUsers);
      bodyFormData.append("action", "survey_released");
      const response = await submitFormData("sentsurveyrequest", bodyFormData);
      if (response.status == "success") {
        toast.success(response.message, { autoClose: 1500 });
        manageSurveyDetails();
        setDesabledBtn(false);
        document.getElementById("closed_popup").click();
      } else {
        setDesabledBtn(false);
        toast.error(response.message, { autoClose: 1500 });
      }
    } else {
      toast.warning("Please Choose One Quality Supervisor", {
        autoClose: 1500,
      });
      setDesabledBtn(false);
      return false;
    }
  };
  const handlersendrequestforsurveydraftreview = async () => {
    setDesabledBtn(true);
    const bodyFormData = new FormData();
    bodyFormData.append("survey_id", surveyID);
    bodyFormData.append("users", notifyUsersData);
    bodyFormData.append("action", "survey_released");
    const response = await submitFormData("sentsurveyrequest", bodyFormData);
    if (response.status === "success") {
      manageSurveyDetails();
      toast.success(response.message, { autoClose: 1500 });
      setDesabledBtn(false);
    } else {
      setDesabledBtn(false);
      toast.error(response.message, { autoClose: 1500 });
    }
  };

  return (
    <div>
      {desabledBtn&&(
        <div style={{
          zIndex:100000,
          display:"flex",
          justifyContent:"center",
          alignItems:"center",
          position: "fixed",
         inset:0,
          backgroundColor: 'rgba(86, 86, 86, 0.8)'
        }}>
        <ScaleLoader
  color="#F58634"
  height={100}
  margin={5}
  radius={8}
  width={20}
/>
        </div>
      )}
      <div
        className="modal fade show"
        id="modal-edit-completion-date"
        arial-modal="true"
      >
        <input type="hidden" id="deleteListsite" value=""></input>
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Edit Completion Date </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="close_modal"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="row">
                <div className="col-md-12">
                  <input
                    type="date"
                    className="form-control"
                    placeholder="Completion Date"
                    min={minDate}
                    value={editCompletionDate}
                    onChange={(e) => {
                      setEditCompletionDate(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                data-dismiss="modal"
                className="btn btn-sm btn-dark"
              >
                Cancel
              </button>
              <button
                type="button"
                data-dismiss="modal"
                className="btn btn-sm custom-btn-primary"
                onClick={() => {
                  handleEditCompletionDate();
                }}
              >
                Submit
              </button>
            </div>
          </div>
        </div>
      </div>
      <div
        className="modal fade show"
        id="survey_released_popup"
        arial-modal="true"
      >
        <input type="hidden" id="deleteListsite" value=""></input>
        <div className="modal-dialog" style={{maxWidth:"600px"}}>
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">Confirm </h4>
              <button
                type="button"
                className="close"
                data-dismiss="modal"
                aria-label="Close"
                id="close_modal"
              >
                <span aria-hidden="true">×</span>
              </button>
            </div>
            <div className="modal-body">
              <table
                id="userlist1"
                className="table table-bordered table-striped"
              >
                <thead>
                  <tr>
                    <th></th>
                    <th>Name</th>
                    <th>Email</th>
                    <th>Role</th>
                  </tr>
                </thead>
                <tbody>
                  {listUsers.length > 0 ? (
                    listUsers.map((item, i) => (
                      <tr key={++i}>
                        <td>
                          <input
                            type="checkbox"
                            data-role={item.role}
                            name={item.user_id}
                            checked={item?.isChecked || false}
                            disabled={item?.disabled || false}
                            onChange={handleChangeUsers}
                          />
                        </td>
                        <td>{item.first_name} {item.last_name}</td>
                        <td>{item?.email}</td>
                        <td>{item.role}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={3} className="text-center">
                        Result not found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                data-dismiss="modal"
                className="btn btn-sm btn-dark"
                id="closed_popup"
              >
                Cancel
              </button>
              <button
                type="button"
                className="btn btn-sm custom-btn-primary"
                onClick={() => {
                  handlersendrequesttousers();
                }}
                disabled={desabledBtn}
              >
                OK
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="wrapper">
        <div>
        
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card card-default">
                      <div className="card-header">
                        <div className="row">
                          <div className="col-md-6">
                            {isSurveyEdit === 1 && (
                              <Link
                                to={"/AdminEditSurveyQuestion/" + surveyID}
                                className="btn btn-sm custom-btn-primary"
                              >
                                <i className="fa fa-edit"></i> Edit
                              </Link>
                            )}
                          </div>
                          <div className="col-md-6">
                            <Link
                              to="/survey"
                              className="btn btn-sm custom-btn-primary pull-right"
                            >
                              <i className="fa fa-arrow-left"></i> Back
                            </Link>
                          </div>
                        </div>
                      </div>

                      <div className="card-body">
                        <div className="row">
                          <div className="col-md-12">
                            <div className="box">
                              <div className="box-body">
                                <div className="table-responsive">
                                  <table className="table table-bordered border-zero">
                                    <colgroup>
                                      <col span={1} className="width-20" />
                                      <col span={1} className="width-40" />
                                      <col span={1} className="width-40" />
                                    </colgroup>
                                    <tbody>
                                      <tr>
                                        <td colSpan={2}>
                                          <center>
                                            <img
                                              className="logo-style"
                                              src={
                                                surveyDetails.manufacturer__company_logo
                                              }
                                              alt="Logo image  not available"
                                            />
                                          </center>
                                          <center>
                                            <span>
                                              {
                                                surveyDetails.manufacturer__company_name
                                              }
                                            </span>
                                          </center>
                                        </td>
                                        <td
                                          rowSpan={7}
                                          className="vertical-middle-align"
                                        >
                                          <center>
                                            <img
                                              className="device-image-style"
                                              src={
                                                surveyDetails.device__device_image
                                              }
                                              alt="Device image not available"
                                            />
                                          </center>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td colSpan={2}>
                                          <center>
                                            <span>
                                              <b>{surveyDetails.survey_name}</b>
                                            </span>
                                            <center />
                                          </center>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="padding-5">
                                          <span> &nbsp;{surveyDetails.user_type===3?"Primary User": "Secondary User"}</span>
                                        </td>
                                        <td className="padding-5">
                                          {`${surveyDetails.first_name} ${surveyDetails.last_name} (${surveyDetails.email})`}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="padding-5">
                                          <span>&nbsp;Survey ID</span>
                                        </td>
                                        <td className="padding-5">
                                          {generateSurveyID(
                                            surveyDetails.site_id,
                                            surveyDetails.survey_id
                                          )}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="padding-5">
                                          <span>&nbsp;Device ID</span>
                                        </td>
                                        <td className="padding-5">
                                          {generateDeviceID(
                                            surveyDetails.site_id,
                                            surveyDetails.device_id
                                          )}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="padding-5">
                                          <span>
                                            &nbsp;Participant Group ID
                                          </span>
                                        </td>
                                        <td className="padding-5">
                                          <Link
                                            to={
                                              "/AdminListParticipants/" +
                                              surveyDetails.participant_group_id
                                            }
                                          >
                                            {generateParticipantGroupID(
                                              surveyDetails.site_id,
                                              surveyDetails.participant_group_id
                                            )}
                                          </Link>
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="padding-5">
                                          <span>&nbsp;Launch Date</span>
                                        </td>
                                        <td className="padding-5">
                                          {surveyDetails.launch_date
                                            ? get_Date(
                                                surveyDetails.launch_date
                                              )
                                            : "Survey yet to be launched"}
                                        </td>
                                      </tr>
                                      <tr>
                                        <td className="padding-5">
                                          <span>&nbsp;Completion Date</span>
                                        </td>
                                        <td className="padding-5">
                                          {get_Date(
                                            surveyDetails.completion_date
                                          )}
                                        </td>
                                        <td className="padding-5">
                                          <center>
                                            {" "}
                                            {surveyDetails.device__device_name}
                                          </center>
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                              {surveyFeedback && (
                                <div className="box-body">
                                  <div className="table-responsive">
                                    <table className="table table-bordered border-zero">
                                      <tr>
                                        <td colSpan={4}>
                                          <h5>Feedback</h5>
                                        </td>
                                      </tr>
                                      <tr>
                                        <th>User Name</th>
                                        <th>Role</th>
                                        <th>Comments</th>
                                        <th>Survey Status</th>
                                        <th>Date</th>
                                        <th>Time</th>
                                      </tr>
                                      <tbody>
                                        {surveyFeedback.map((item, i) => (
                                          <tr key={i}>
                                            <td className="padding-5">
                                              <span>{item.user_name}</span>
                                            </td>
                                            <td className="padding-5">
                                              <span>{item.role}</span>
                                            </td>
                                            <td className="padding-5">
                                              <span>{item.comment}</span>
                                            </td>
                                            <td className="padding-5">
                                              <span>
                                                {getSurveyStatusName(
                                                  item.survey_action
                                                )}
                                              </span>
                                            </td>
                                            <td className="padding-5">
                                              <span>
                                                {get_Date(item.date_time)}
                                              </span>
                                            </td>
                                            <td className="padding-5">
                                              <span>
                                                {time_with_AMPM(item.date_time)}
                                              </span>
                                            </td>
                                          </tr>
                                        ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      <div className="card-footer clearfix">
                        <div className="row">
                          <div className="col-md-3">
                            <Link
                              to={"/AdminFormView/" + surveyID}
                              className="btn btn-sm custom-btn-primary"
                            >
                              Preview
                            </Link>{" "}
                            <Link
                              to={"/AdminListResponses/" + surveyID}
                              className={
                                buttonDisplay("Responses", surveyDetails.status)
                                  ? "btn btn-sm custom-btn-primary"
                                  : "btn btn-sm custom-btn-primary hidden-custom"
                              }
                            >
                              Responses
                            </Link>{" "}
                            <Link
                              to={"/AdminCreateAnalysis/" + surveyID}
                              className={
                                buttonDisplay("Analysis", surveyDetails.status)
                                  ? "btn btn-sm custom-btn-primary"
                                  : "btn btn-sm custom-btn-primary hidden-custom"
                              }
                            >
                              Analysis
                            </Link>{" "}
                          </div>
                          <div className="col-md-9">
                            <div className="pull-right">
                              <button
                                className={
                                  buttonDisplay(
                                    "Save Final Draft",
                                    surveyDetails.status
                                  )
                                    ? "btn btn-sm custom-btn-primary"
                                    : "btn btn-sm custom-btn-primary hidden-custom"
                                }
                                onClick={() => {
                                  handleSurveyStatus(
                                    "draft_released_to_primary_user"
                                  );
                                }}
                              >
                                Save Final Draft
                              </button>{" "}
                              <button
                                className={
                                  buttonDisplay(
                                    "Launch Survey",
                                    surveyDetails.status
                                  )
                                    ? "btn btn-sm custom-btn-primary"
                                    : "btn btn-sm custom-btn-primary hidden-custom"
                                }
                                onClick={() => {
                                  handleSurveyStatus("launched");
                                }}
                                disabled={disable}
                              >
                                {disable ? (
                                  <>
                                    <span
                                      className="spinner-border spinner-border-sm"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    Loading...
                                  </>
                                ) : (
                                  "Launch Survey"
                                )}
                              </button>{" "}
                              <button
                                data-toggle="modal"
                                data-target="#modal-edit-completion-date"
                                className={
                                  buttonDisplay(
                                    "Launch Survey",
                                    surveyDetails.status
                                  )
                                    ? "btn btn-sm custom-btn-primary"
                                    : "btn btn-sm custom-btn-primary hidden-custom"
                                }
                              >
                                Edit Completion Date
                              </button>{" "}
                              {surveyDetails.status == "final_save" && (
                                <>
                                  <button
                                    className={
                                      buttonDisplay(
                                        "Release Survey to Primary User",
                                        surveyDetails.status
                                      )
                                        ? "btn btn-sm custom-btn-primary"
                                        : "btn btn-sm custom-btn-primary hidden-custom"
                                    }
                                    data-toggle="modal"
                                    data-target="#survey_released_popup"
                                  >
                                    Release Survey
                                  </button>{" "}
                                </>
                              )}
                              <button
                                className={
                                  buttonDisplay(
                                    "Close survey",
                                    surveyDetails.status
                                  )
                                    ? "btn btn-sm custom-btn-primary"
                                    : "btn btn-sm custom-btn-primary hidden-custom"
                                }
                                onClick={() => {
                                  handleSurveyStatus("survey_closed");
                                }}
                              >
                                Close survey
                              </button>{" "}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-md-12">
                    <div className="create-question-stepper">
                      <ul className="stepper-nav-list">
                        <li className="active">
                          <a>Draft Created</a>
                        </li>
                        <li
                          className={
                            activeProcessBar(
                              "Draft Released",
                              surveyDetails.status
                            )
                              ? "active"
                              : ""
                          }
                        >
                          <a>Draft Released</a>
                        </li>
                        <li
                          className={
                            activeProcessBar(
                              "Draft Approved",
                              surveyDetails.status
                            )
                              ? "active"
                              : ""
                          }
                        >
                          <a>Draft Approved</a>
                        </li>
                        <li
                          className={
                            activeProcessBar("Launched", surveyDetails.status)
                              ? "active"
                              : ""
                          }
                        >
                          <a>Launched</a>
                        </li>
                        <li
                          className={
                            activeProcessBar("Completed", surveyDetails.status)
                              ? "active"
                              : ""
                          }
                        >
                          <a>Completed</a>
                        </li>
                        <li
                          className={
                            activeProcessBar(
                              "Survey Released",
                              surveyDetails.status
                            )
                              ? "active"
                              : ""
                          }
                        >
                          <a>Survey Released</a>
                        </li>
                        <li
                          className={
                            activeProcessBar(
                              "Survey Approved",
                              surveyDetails.status
                            )
                              ? "active"
                              : ""
                          }
                        >
                          <a>Survey Approved</a>
                        </li>
                        <li
                          className={
                            activeProcessBar(
                              "Survey Closed",
                              surveyDetails.status
                            )
                              ? "active"
                              : ""
                          }
                        >
                          <a>Survey Closed</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>

          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default AdminSurveyDetails;
